import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "@/utils/axiosInstance";
import { handleThunkError } from "@/utils/thunkErrorHandler";

const endpoint = {
  createCustomer: `${process.env.NEXT_PUBLIC_API_URL}/stripe/customers`,
  createSepaSetupSession: `${process.env.NEXT_PUBLIC_API_URL}/stripe/setup-sessions/sepa`,
  finalizeSepa: `${process.env.NEXT_PUBLIC_API_URL}/stripe/setup-sessions/sepa/finalize`,
};

export const createStripeCustomer = createAsyncThunk(
  "stripe/createStripeCustomer",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.post(endpoint.createCustomer, data);
      return response.data;
    } catch (error) {
      return handleThunkError(error, thunkAPI, "Erro ao criar customer Stripe");
    }
  },
);

export const createSepaSetupSession = createAsyncThunk(
  "stripe/createSepaSetupSession",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoint.createSepaSetupSession,
        data,
      );
      return response.data;
    } catch (error) {
      return handleThunkError(error, thunkAPI, "Erro ao criar sessão SEPA");
    }
  },
);

export const finalizeSepaSetupSession = createAsyncThunk(
  "stripe/finalizeSepaSetupSession",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.post(endpoint.finalizeSepa, data);
      return response.data;
    } catch (error) {
      return handleThunkError(error, thunkAPI, "Erro ao finalizar sessão SEPA");
    }
  },
);
